module.exports = __webpack_public_path__ + "static/img/s-mi-5.579234f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-5.png
// module id = GLer
// module chunks = 1